import type { IssueLayoutConfigurationResponse } from '@atlassian/jira-business-summary-services/src/services/types.tsx';

export const transformIssueLayoutConfiguration = (data: IssueLayoutConfigurationResponse) => ({
	...data.issueLayoutConfiguration.issueLayoutResult,
	owners: {
		...data.issueLayoutConfiguration.issueLayoutResult.usageInfo?.edges[0]?.node.layoutOwners[0],
	},
	usageInfo: undefined,
});
